export default __webpack_public_path__ + "static/media/run-buddy.186901b9.png";